<template>
  <div class="Topbar" :class="{'showBox':logs}">
    <div v-if="logs" class="logBox">
      <router-link tag='a' to="/">
        <img src="/static/images/log.png">
      </router-link>
    </div>
    <ul class="clearfix d-none d-lg-block">
      <router-link v-if="!localUser" to="/login">
        登录
      </router-link>
      <a @click="loginOutFun" v-if="localUser!==null">
        退出
      </a>
      <router-link v-for="(app,index) in navList" :key="index" :to="app.path">
        {{app.name}}
      </router-link>
    </ul>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import commons from '@/util/commons';

export default {
  name: 'Topbar',
  mixins: [generalMix],
  props:{
    logs: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    	navList:[
        {
          name:'资讯',
          path:'/article'
        },
        {
          name:'关于',
          path:'/about'
        },
        {
          name:'首页',
          path:'/'
        }
    	]
    }
  },
  methods:{
    loginOutFun() {
      return window.swal({
        title: '确定退出吗?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          // 删除本地存储
          const result = commons.saveTodos('localUser', null);
          if (result) {
            // 更新登陆状态
            this.saveLocaluserFun({ bool: false });
            // 提示
            this.$message.showMsgBox({
              type: 'success',
              content: '退出成功'
            });
            // 跳转首页
            if(this.$router.history.current.path !== '/login'){
              this.$router.push({ path: '/login' });
            }
          } else {
            this.$message.showMsgBox({
              type: 'danger',
              content: '退出失败'
            });
          }
        }
      });
    }
  },
  created() {
  }
}
</script>

<style scoped lang='less'>
  .Topbar{
    padding: 2rem 0;
    padding-top: 43px;
    /*border-bottom: 2px dashed rgba(0,0,0,0.3) !important;*/
    ul{
      a{
        float: right;
        color: #FFFFFF;
        margin-left: 20px;
        &:last-child{
          margin: 0;
        }
      }
    }
    &.showBox{
      padding: 0;
      display: flex;
      justify-content: space-between;
      padding-bottom: 20px;
      .logBox{
        margin-top: 40px;
        img{
          height: 50px;
        }
      }
      ul{
        padding: 2rem 0;
        padding-top: 43px;
      }
    }
  }
  @media (max-width: 992px) {
    .Topbar{
      border-bottom: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Topbar.vue